import { range } from 'ramda';
export const pageLinksValues = ({ page, pages, visibleButtons, }) => {
    const result = [];
    const FIRST_PAGE_INDEX = 1;
    const LAST_PAGE_INDEX = pages;
    // Handle case where total pages are less than or equal to visibleButtons
    if (pages <= visibleButtons) {
        return range(FIRST_PAGE_INDEX, LAST_PAGE_INDEX + 1);
    }
    const halfVisible = Math.floor(visibleButtons / 2);
    let startPage = Math.max(FIRST_PAGE_INDEX, page - halfVisible);
    let endPage = Math.min(LAST_PAGE_INDEX, page + halfVisible);
    // Adjust if we are near the edges
    if (startPage === FIRST_PAGE_INDEX) {
        endPage = Math.min(LAST_PAGE_INDEX, startPage + visibleButtons - 1);
    }
    else if (endPage === LAST_PAGE_INDEX) {
        startPage = Math.max(FIRST_PAGE_INDEX, endPage - visibleButtons + 1);
    }
    // Add first page and ellipses if needed
    if (startPage > FIRST_PAGE_INDEX + 1) {
        result.push(FIRST_PAGE_INDEX, -1); // Add ellipsis after the first page
    }
    else if (startPage > FIRST_PAGE_INDEX) {
        result.push(FIRST_PAGE_INDEX);
    }
    // Add visible page numbers
    for (let i = startPage; i <= endPage; i++) {
        result.push(i);
    }
    // Add ellipses and last page if needed
    if (endPage < LAST_PAGE_INDEX - 1) {
        result.push(-1, LAST_PAGE_INDEX); // Add ellipsis before the last page
    }
    else if (endPage < LAST_PAGE_INDEX) {
        result.push(LAST_PAGE_INDEX);
    }
    return result;
};
//# sourceMappingURL=utils.js.map